<template>
 <main class="html-page home-page events-page">
<main><section class="page-hero events-hero" data-bloco="eventos-hero" data-tipo="hero"><div class="container events-hero-grid"><div class="events-hero-copy"><p class="eyebrow" data-campo="iti_nome" v-html="html(eventosHero, 'iti_nome')"></p><h1 data-campo="iti_resumo1" v-html="html(eventosHero, 'iti_resumo1')"></h1><p data-campo="iti_descricao1" v-html="html(eventosHero, 'iti_descricao1')"></p><div v-if="eventosLista.length" class="event-filters" role="tablist"><button class="event-filter active" type="button">Próximos eventos</button><button class="event-filter" type="button">Eventos realizados</button></div><p v-else class="events-empty-message">Em breve, nossos eventos.</p></div><div class="events-hero-media"><img alt="Cão representando a agenda de eventos veterinários" data-img="imagem" :src="image(eventosHero)" v-if="image(eventosHero)" @error="hideBrokenImage"></div></div></section>
<section v-if="eventosLista.length" class="section events-section" data-bloco="eventos-lista" data-tipo="lista" :style="bg(eventosLista)"><div class="container events-groups" data-repetidor="eventos-lista">
<div class="event-group active" data-event-group="proximos"><div class="event-month"><span v-html="html(eventosLista, 'iti_titulo')"></span><small v-html="html(eventosLista, 'iti_resumo1')"></small></div><article class="event-row" data-item="" v-for="(item, index) in eventosLista" :key="index"><div class="event-date"><strong v-html="eventDate(item)"></strong><span v-html="html(item, 'iti_campo_extra9')"></span></div><img v-if="image(item)" alt="Evento veterinário" data-img="fotos" :src="image(item)" @error="hideBrokenImage"><div class="event-copy"><span class="tag" v-html="html(item,'iti_referencia')"></span><h2 data-campo="iti_nome" v-html="html(item,'iti_nome')"></h2><p data-campo="iti_resumo1" v-html="html(item,'iti_resumo1')"></p><div class="event-meta"><span v-html="html(item,'iti_campo_extra1')"></span><span v-html="html(item,'iti_campo_extra2')"></span><span v-html="html(item,'iti_campo_extra3')"></span><span v-html="html(item,'iti_campo_extra4')"></span></div></div><div class="event-actions"><a class="btn btn-primary" href="https://wa.me/5551991544590">Mais informações</a></div></article></div>
<div class="event-group" data-event-group="realizados"><div class="event-month"><span></span><small></small></div><div class="event-month"><span></span><small></small></div></div>
</div></section></main>
<a class="whatsapp" href="https://wa.me/5551991544590" aria-label="Falar pelo WhatsApp"><span></span></a>
</main> 
</template>

<script>
import {
  contentValue,
  firstImage,
  gridItems,
  loadScreens,
  normalizeInternalLink,
  applyPageMeta,
} from '@/services/contentApi';

export default {
  name: 'EventosView',
  data() {
    return {
      eventosHero: {},
      eventosLista: [],
      heroSlide: 0,
      carouselSlide: 0,
      carouselTimer: null,
    };
  },
  created() {
    this.loadContent();
  },
  mounted() {
    this.carouselTimer = window.setInterval(() => {
      this.nextHeroSlide();
      this.nextCarouselSlide();
    }, 5500);
  },
  beforeUnmount() {
    if (this.carouselTimer) window.clearInterval(this.carouselTimer);
  },
  methods: {
    text(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    html(source, field, fallback = '') {
      return contentValue(source, field, fallback);
    },
    image(source) { return firstImage(source); },
    hideBrokenImage(event) { event.currentTarget.hidden = true; },
    eventDate(item) { return this.text(item, 'iti_data1') || this.text(item, 'iti_campo_extra9') || 'A confirmar'; },
    bg(source) {
      const url = firstImage(source);
      return url ? { backgroundImage: 'url("' + url + '")' } : {};
    },
    grids(source) {
      return gridItems(source);
    },
    link(source, field, fallback = '') {
      return normalizeInternalLink(contentValue(source, field, fallback), fallback);
    },
    applyMeta(source) {
      applyPageMeta({
        title: contentValue(source, 'iti_resumo1') || contentValue(source, 'iti_nome'),
        description: contentValue(source, 'iti_descricao1') || contentValue(source, 'iti_resumo1'),
        image: firstImage(source),
      });
    },
    nextHeroSlide() {
      const total = this.homeHero?.length || this.$el.querySelectorAll('[data-vue-carousel="hero"] > [data-slide-index]').length || 1;
      this.heroSlide = (this.heroSlide + 1) % total;
    },
    goHeroSlide(index) {
      this.heroSlide = index;
    },
    nextCarouselSlide() {
      const total = this.$el.querySelectorAll('[data-vue-carousel="content"] > [data-slide-index]').length || 1;
      this.carouselSlide = (this.carouselSlide + 1) % total;
    },
    goCarouselSlide(index) {
      this.carouselSlide = index;
    },
    async loadContent() {
      const data = await loadScreens([
        {
          ctiId: 23,
          key: "eventosHero",
          multi: false,
        },
        {
          ctiId: 24,
          key: "eventosLista",
          multi: true,
        },
      ]);

      if (data.eventosHero && Object.keys(data.eventosHero).length) this.eventosHero = data.eventosHero;
      if (Array.isArray(data.eventosLista) && data.eventosLista.length) this.eventosLista = data.eventosLista;
      this.applyMeta(this.eventosHero);
    },
  },
};
</script>

<style scoped>
.events-empty-message {
  margin: 32px 0 0;
  color: var(--brand);
  font-size: 1.05rem;
  font-weight: 900;
}
</style>
